import React from "react";
import CreditUsageTable from "./A_Components/Table";
import { useEmployerAndPlans } from "../../../data/dashboardInightHub";
import { formatFirestoreTStoDate } from "./helper";



const CreditUsage = () => {
    const { data, isloading }: any = useEmployerAndPlans("credit_usage")
    console.log("Credit Usage Data:", data);

    const creditUsageData = data?.creditUsageData?.map(({ planType, activeEmployers, totalCredits, usedCredits, creditsExpiringSoon }: any) => {
        const avgUtilization =
            totalCredits > 0 ? Math.round((usedCredits / totalCredits) * 100) : 0;

        return {
            planType,
            activeEmployers,
            totalCredits,
            usedCredits,
            avgUtilization,
            creditsExpiringSoon
        };
    });

    const getTotalCredits = () => creditUsageData?.reduce((sum: any, item: any) => sum + item.totalCredits, 0);
    const getUsedCredits = () => creditUsageData?.reduce((sum: any, item: any) => sum + item.usedCredits, 0);
    const getCreditsExpiring = () => data?.creditUsageData?.reduce((sum: any, item: any) => sum + item.creditsExpiringSoon, 0);
    const getAvgUtilization = () => {
        const totalUsed = getUsedCredits();
        const totalAvailable = getTotalCredits();
        return Math.round((totalUsed / totalAvailable) * 100);
    };
    const getAvgCreditsPerEmployer = () => {
        const totalEmployers = creditUsageData?.reduce((sum: any, item: any) => sum + item.activeEmployers, 0);
        const totalCredits = getTotalCredits();
        return (totalCredits / totalEmployers).toFixed(1);
    };
    const totalCredits = getTotalCredits();
    const usedCredits = getUsedCredits();
    const creditsExpiring = getCreditsExpiring();
    const avgUtilization = getAvgUtilization();
    const avgCreditsPerEmployer = getAvgCreditsPerEmployer();
    const addedThisMonth = 156;
  const lastUpdatedAt = formatFirestoreTStoDate(data?.updatedAt);
    return (
        <div className="bg-white p-6 rounded-2xl shadow-sm">
            <div className="space-y-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-bold text-[#183853]">Credit Usage</h2>
                   { lastUpdatedAt&&<p className='text-instant-teams-blue-Main text-lg font-semibold'>{`Last updated:  ${lastUpdatedAt}`}</p>}

                </div>
            </div>

            <div className="grid gap-4 grid-cols-4 mt-6">
                {/* TOTAL CREDITS PURCHASED */}
                <div className="p-5 rounded-2xl col-span-1 border border-gray-200 shadow-sm transition">
                    <p className="text-sm font-medium text-gray-500">TOTAL CREDITS PURCHASED</p>
                    <div className="text-4xl font-bold text-[#183853] mt-2">{totalCredits?.toLocaleString() || 0}</div>
                    {/* <p className="text-sm text-green-600 mt-1">+{addedThisMonth} this month</p> */}
                </div>

                {/* CREDITS USED */}
                <div className="p-5 rounded-2xl border border-gray-200 shadow-sm  transition">
                    <p className="text-sm font-medium text-gray-500">CREDITS USED</p>
                    <div className="text-4xl font-bold text-[#183853] mt-2">{usedCredits?.toLocaleString()}</div>
                    <p className="text-sm text-gray-500 mt-1">{isloading ? "..." : avgUtilization || 0}% utilization</p>
                </div>


                <div className="p-5 rounded-2xl border border-gray-200 shadow-sm  transition">
                    <p className="text-sm font-medium text-gray-500">CREDITS EXPIRING ( 7 DAYS )</p>
                    <div className="text-4xl font-bold text-[#183853] mt-2">{isloading ? "..." : creditsExpiring || 0}</div>
                    <p className="text-sm text-red-600 mt-1">Potential waste</p>
                </div>

                {/* AVG. CREDITS PER EMPLOYER */}
                <div className="p-5 rounded-2xl border border-gray-200 shadow-sm  transition">
                    <p className="text-sm font-medium text-gray-500">AVG. CREDITS PER EMPLOYER</p>
                    <div className="text-4xl font-bold text-[#183853] mt-2">{isloading ? "..." : avgCreditsPerEmployer || 0}</div>
                    {/* <p className="text-sm text-green-600 mt-1">+1.2 vs last month</p> */}
                </div>
            </div>
            <div className="mt-4">
                <CreditUsageTable creditUsageData={creditUsageData} />
            </div>
        </div>
    );
};

export default CreditUsage;
